import { KillswitchPage } from './KillswitchPage';
export default KillswitchPage;